<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Svelte hooks
	import { beforeUpdate, createEventDispatcher } from 'svelte';
	//Stores
	import {
		device_notifications,
		dismissed_notifications,
	} from 'src/stores/features/device-notifications';
	//Helpers
	import { capFirstChar } from '../helpers/utilities';
	import {
		dismissNotification,
		getNotificationsForDevice,
	} from 'src/helpers/notifications/device_notifications_helper';
	//Design system components
	import { Alert, Stack, Text, CircleAvatar } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { getDeviceState, defaultStateType } from 'src/stores/device-runtime/states';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	//Types

	export let device;

	const dispatch = createEventDispatcher();
	const timeToClear = 86400; //24 hours to clear seen notification

	$: sidePanelDeviceStateStore = getDeviceState($sidePanelStateCombined?.id);
	$: sidePanelDeviceState = $sidePanelDeviceStateStore;
	$: notificationsToShow = $device_notifications && getNotificationsForDevice(device?.id);

	beforeUpdate(() => {
		const time = +(new Date().getTime() / 1000).toFixed(0);

		Object.entries($dismissed_notifications).forEach(([id, ts]) => {
			if (time - Number(ts) > timeToClear) {
				dismissed_notifications.remove(id);
			}
		});
	});
</script>

{#if Object.keys(notificationsToShow).length > 0}
	<Text element="h2" class="mb-s">
		{capFirstChar($format('settings_title_notifications', { default: 'Notifications' }))}
		({Object.keys(notificationsToShow).length})
	</Text>
	<Stack gap="xs" class="mb-s">
		{#each Object.values(notificationsToShow) as { type, heading, id, ctaLocal, message, messageHighlight, error, dismissable }}
			{@const isDisabled = sidePanelDeviceState?.type < defaultStateType}
			<Alert
				type={type == 'promo' ? 'info' : type}
				{...error ? { customIcon: 'text-warning fas fa-shield-exclamation' } : {}}
				heading={heading?.local ?? heading?.global}
				dismissable={dismissable ?? true}
				on:dismissable_click={() => dismissNotification(id)}
				class={typeof $dismissed_notifications[id] !== 'undefined' ? 'dismissable' : ''}
				isHeadingBold={!!message}
				hideSlotBottom={ctaLocal?.title === '' || (!ctaLocal?.title && !message)}
			>
				<svelte:fragment slot="bottom">
					{#if message}
						<Text
							class={classMap({
								'mb-s': ctaLocal?.title && !isDisabled,
							})}
							styleType="body-small"
						>
							<span class="text-bold">{device?.name}</span>
							{#if messageHighlight}
								{' '}<span class="text-bold">{messageHighlight}</span>{' '}
							{/if}
							{message}
						</Text>
					{/if}
					{#if ctaLocal?.title}
						<button
							class="reset-button-styles-base link-styles d-flex align-items-start"
							style="font-size: 13px; line-height: 16px;"
							type="button"
							on:click={(event) => {
								event.stopPropagation();
								dispatch(`${ctaLocal?.onClick()}`);
							}}
						>
							{ctaLocal?.title}
						</button>
					{/if}
				</svelte:fragment>
			</Alert>
		{/each}
	</Stack>
{:else if device}
	<div class="flex-full-height align-items-center justify-content-center">
		<CircleAvatar class="mb-l" size="xxl" icon="fa-thin fa-bell" />
		<Text element="h2" class="mb-s text-bold text-center">
			{capFirstChar($format('no_notifications_msg', { default: 'No Notifications' }))}.
		</Text>
		<Text class="text-color-muted text-center" styleType="body-small">
			{$format('new_notifications_desc', {
				default: "When something new arrives, you'll see it here.",
			})}</Text
		>
	</div>
{:else}
	<Text element="h2" class="mb-s">
		{capFirstChar($format('no_notifications_msg', { default: 'No Notifications' }))}.
	</Text>

	<Text styleType="body-small">
		{$format('new_notifications_desc', {
			default: "When something new arrives, you'll see it here.",
		})}</Text
	>
{/if}
